<template>
  <div class="mm-page-main" v-loading="loading">
    <div class="page-header">
      <div class="page-title">設置小票機</div>
      <div @click="pageback" class="page-back">
        <svg class="icon svg-icon" aria-hidden="true">
          <use xlink:href="#icon-back"></use>
        </svg>
      </div>
    </div>
    <div v-if="tabs.length>0" class="mm-tabs">
      <div class="mm-tabsulbox">
        <div @click="tableft" class="tabsleftico"><i class="el-icon-arrow-left"></i></div>
        <ul :style="transform" class="mm-tabs-card">
          <li @click.stop="changetab(tab.type)" :class="{active:form.type== tab.type}" v-for="(tab,index) in tabs" :key="index">{{tab.name}}</li>
        </ul>
        <div @click="tabright" class="tabsrightico"><i class="el-icon-arrow-right"></i></div>
      </div>
      <div class="mm-tabs-content">
        <div class="pagemain">
          <el-form ref="form" :model="form" :rules="rules" label-width="0" label-position="left">
            <div class="form-group">
              <div class="mm-row" v-show="form.type==0">
                <div class="mm-col">
                  <el-form-item prop="exchange_content">
                    <el-input type="textarea" autosize maxlength="5000" show-word-limit placeholder="请输入内容" v-model="form.exchange_content">
                    </el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="mm-row" v-show="form.type==1">
                <div class="mm-col">
                  <el-form-item prop="remit_content">
                    <el-input type="textarea" autosize maxlength="5000" show-word-limit placeholder="请输入内容" v-model="form.remit_content">
                    </el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="mm-row" v-show="form.type==2">
                <div class="mm-col">
                  <el-form-item prop="checkday_content">
                    <el-input type="textarea" autosize maxlength="5000" show-word-limit placeholder="请输入内容" v-model="form.checkday_content">
                    </el-input>
                  </el-form-item>
                </div>
              </div>
            </div>
            <div class="form-submit" v-show="form.type!=3">
              <div class="mm-col">
                <el-form-item>
                  <el-button @click="formsubmit('form')" type="primary">保存</el-button>
                  <el-button @click="beforefeprint()" type="info">打印測試</el-button>
                  <el-button @click="reset()" type="info">導入模板</el-button>
                </el-form-item>
              </div>
            </div>
            <div class="mm-row" v-show="form.type==3">
              <div class="mm-col">
                <el-card shadow="never">
                  <div>
                    在上方編輯框輸入任意文字,在需要的地方插入下列代碼,即可在小票自動顯示對應訂單的數據.點擊打印以測試效果<br><br>
                    // 牌照/門店相關<br>
                    [##CompanyName##] 替換為數據庫內的 [公司名稱]<br>
                    [##StoreName##] 替換為數據庫內的 [門店名稱]<br>
                    [##StoreAddress##] 替換為數據庫內的 [門店地址]<br>
                    [##StorePhone##] 替換為數據庫內的 [門店電話]<br>
                    [##StoreEmail##] 替換為數據庫內的 [門店郵箱]<br>
                    [##StoreFax##] 替換為數據庫內的 [門店傳真]<br>
                    [##StoreWhatsapp##] 替換為數據庫內的 [門店Whatsapp]<br><br>

                    // 訂單相關<br>
                    [##OrderNumber##] 替換為數據庫內的 [訂單ID編號]<br>
                    [##PrintDate##] 替換為數據庫內的 [打印日期時間]<br>
                    [##OrderDate##] 替換為數據庫內的 [訂單日期時間]<br>
                    [##SellingCurrency##] 替換為數據庫內的 [賣出貨幣]<br>
                    [##SellingAmount##] 替換為數據庫內的 [賣出金額]<br>
                    [##ExchangeRate##] 替換為數據庫內的 [匯率]<br>
                    [##BuyCurrency##] 替換為數據庫內的 [買入貨幣]<br>
                    [##BuyAmount##] 替換為數據庫內的 [買入金額(不含手續費)]<br>
                    [##CustomerName##] 替換為數據庫內的 [指示人姓名]<br>
                    <!-- [##CustomerNameEnCh##] 替換為數據庫內的 [指示人姓名_中英文]<br>
        例如: 潘先生(Mr. Pan) 若數據庫內沒有英文姓名字段,則只顯示: 潘先生 若只有英文字段,則顯示 Mr. pan<br> -->
                    [##CustomerNameEn##] 替換為數據庫內的 [指示人姓名_英文]<br>
                    [##CustomerPhone##] 替換為數據庫內的 [指示人電話]<br>
                    [##PayeeName##] 替換為數據庫內的 [收款人姓名]<br>
                    [##PayeePhone##] 替換為數據庫內的 [收款人電話]<br>
                    [##PayeeAccount##] 替換為數據庫內的 [收款人帳戶]<br>
                    [##PayeeBank##] 替換為數據庫內的 [收款人銀行]<br>
                    [##PayeeBankSubBranch##] 替換為數據庫內的 [支行]<br>
                    [##PayeeAmount##] 替換為數據庫內的 [收款人金額]<br>
                    [##PayeeAmountCurrency##] 替換為數據庫內的 [收款人金額_貨幣]<br>
                    [##PayeeAddress##] 替換為數據庫內的 [收款人地址]<br>
                    [##FeeCurrency##] 替換為數據庫內的 [手續費貨幣]<br>
                    [##FeeAmount##] 替換為數據庫內的 [手續費]<br>
                    [##Remarks##] 替換為數據庫內的 [備注]<br>
                    [##OperatorAccount##] 替換為數據庫內的 [當前訂單的操作員賬號]<br>
                    [##OperatorName##] 替換為數據庫內的 [當前訂單的操作員名稱]<br>
                    [##TotalCurrency##] 替換為數據庫內的 [共計貨幣]<br>
                    [##TotalAmount##] 替換為數據庫內的 [共計金額(含手續費)]<br><br>

                    // 訂單找零<br>
                    [##AmountPayable##] 替換為數據庫內的 [訂單應付金額]<br>
                    [##AmountReceived##] 替換為數據庫內的 [訂單實收金額]<br>
                    [##AmountChange##] 替換為數據庫內的 [訂單應找金額]<br>
                    [##ChangeCurrency##] 替換為數據庫內的 [訂單找零貨幣]<br><br>

                    // 日結數據相關<br>
                    [##SettlementData##] 替換為數據庫內的 [日結數據結構] 數據結構如下<br>
                    <pre>
港幣  剩餘           折合HKD        匯率
CNY   -2575.38       -2769.23       0.93
HKD   -10003495.74   -10003495.74   1
USD   0              0.00           5
CAD   0              0.00           0
        </pre>
                    [##SettlementNumber##] 替換為數據庫內的 [門店日結編號]<br>
                    [##SettlementType##] 替換為數據庫內的 [門店日結數據結構]，由數據庫查詢統計得到 <br>
                    [##SettlementStartDate##] 替換為數據庫內的 [門店日結結束時間]<br>
                    [##SettlementEndDate##] 替換為數據庫內的 [門店日結開始時間]<br>
                    [##SettlementTotal##] 替換為數據庫內的 [門店日結縂合計]<br>
                    [##LastSettlementTotal##] 替換為數據庫內的 [門店上一次日結縂合計]<br>
                    [##SettlementProfit##] 替換為數據庫內的 [門店日結差額]<br><br>

                    // 以下是橫綫替換<br>
                    [##DashedLine80##] 自動設置80mm【-----】虛綫橫綫<br>
                    [##SolidLine80##] 自動設置80mm【___】實綫橫綫<br>
                    [##DottedLine80##] 自動設置80mm【.....】點綫橫綫<br><br>

                    //以下是排版指令<br>
                    &lt;BR&gt; ：換行符<br>
                    <!-- &lt;CUT&gt; ：切刀指令(主動切紙,僅限切刀打印機使用才有效果)<br> -->
                    &lt;LOGO&gt; ：打印LOGO指令(前提是預先在機器內置LOGO圖片)<br>
                    &lt;PLUGIN&gt; ：錢箱或者外置音響指令<br>
                    &lt;CB&gt;&lt;/CB&gt;：居中放大<br>
                    &lt;B&gt;&lt;/B&gt;：放大一倍<br>
                    &lt;C&gt;&lt;/C&gt;：居中<br>
                    &lt;L&gt;&lt;/L&gt;：字體變高一倍<br>
                    &lt;W&gt;&lt;/W&gt;：字體變寬一倍<br>
                    &lt;QR&gt;&lt;/QR&gt;：二維碼（單個訂單，最多只能打印一個二維碼）<br>
                    &lt;RIGHT&gt;&lt;/RIGHT&gt;：右對齊<br>
                    &lt;BOLD&gt;&lt;/BOLD&gt;：字體加粗
                  </div>
                </el-card>
              </div>
            </div>
          </el-form>
        </div>
      </div>
    </div>
    <el-dialog title="請選擇熱敏小票機" :visible.sync="feprintDialogVisible" width="80%" :close-on-click-modal="false">
      <div>
        <el-select v-model="feprint_id" placeholder="請選擇">
          <el-option v-for="item in feprintlist" :key="item.id" :label="(item.scene==0?'【門店】':'【辦公室】')+item.name" :value="item.id">
          </el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="feprintDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="printtest()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {

  data () {
    return {
      loading: false,
      feprint_id: '',
      feprintDialogVisible: false,
      feprintlist: [],
      tabs: [
        { type: 0, name: '兌換單設置' },
        { type: 1, name: '匯款單設置' },
        { type: 2, name: '日結單設置' },
        { type: 3, name: '配置指南' },
      ],
      transform: '',
      transformnum: 0,
      form: {
        type: 0,
        store_id: 0,
        exchange_content: '',
        remit_content: '',
        checkday_content: '',
      },
      rules: {



      }
    };
  },
  methods: {
    changetab (type) {
      this.form.type = type;
    },
    pageback () {
      this.$router.go(-1);
    },
    tableft () {
      let num = this.transformnum - 1;
      if (num >= 0) {
        this.transform = 'transform:translate3d(' + (-85 * num) + 'px,0,0)';
        this.transformnum = num;
      }

    },
    tabright () {
      let num = this.transformnum + 1;
      if (num < this.tabs.length - 1) {
        this.transform = 'transform:translate3d(' + (-85 * num) + 'px,0,0)';
        this.transformnum = num;
      }
    },
    getfrprint_template (id) {
      this.post('/api/frprint/getfrprint_template', {
        store_id: id
      }).then((res) => {
        this.loading = false;
        if (res) {
          this.form.exchange_content = res.exchange_content;
          this.form.remit_content = res.remit_content;
          this.form.checkday_content = res.checkday_content;
        }
      }).catch((err) => {
        this.loading = false;
        console.log(err)
      });
    },
    formsubmit (form) {

      this.$refs[form].validate((valid) => {
        if (valid) {
          this.loading = true;
          let data = this.form;
          this.post('/api/frprint/setsave', {
            data: data
          }).then((res) => {
            this.loading = false;
            if (res == 'success') {
              this.$message({
                showClose: true,
                message: '設置成功！',
                type: 'success',

              });
            } else {
              this.$message({
                showClose: true,
                message: '設置失敗，請重試！',
                type: 'error',

              });
            }

            this.getfrprint_template(this.form.store_id);

          }).catch((err) => {
            this.loading = false;
            console.log(err)
          });
        }
      });
    },
    async getfeprint () {
      this.feprint_id = '';
      let store_id = this.form.store_id;
      await this.post('/api/frprint/getfeprint', {
        store_id
      }).then(response => {
        response = response.filter(item => {
          return item.status == 0 ? true : false;
        })
        this.feprintlist = response;
      }).catch(error => {
        console.log(error);
      });
    },
    async beforefeprint () {
      await this.getfeprint();

      if (this.feprintlist.length == 0) {
        this.$notify({
          showClose: true,
          message: '請先添加/開啓小票機！',
          type: 'error',
          offset: 160,
        });
        return false;
      } else if (this.feprintlist.length > 1) {
        this.feprintDialogVisible = true;
      } else if (this.feprintlist.length == 1) {
        this.feprint_id = this.feprintlist[0].id;
        this.printtest();
      }

    },
    printtest () {
      let print_id = this.feprint_id;
      if (print_id == '') {
        this.$notify({
          showClose: true,
          message: '請先選擇熱敏小票機！',
          type: 'error',
          offset: 160,
        });
        return false;
      }
      this.feprintDialogVisible = false;
      let store_id = this.form.store_id;
      let type = this.form.type;
      this.post('/api/frprint/printtest', {
        type,
        store_id,
        print_id
      }).then(response => {
        console.log(response);
        if (response.msg == 'ok') {
          this.$notify({
            showClose: true,
            message: '打印指令已發送！',
            type: 'success',
            offset: 160
          });
        } else {
          this.$notify({
            showClose: true,
            message: response.msg,
            type: 'error',
            offset: 160
          });
        }
      }).catch(error => {
        console.log(error)
      });
    },
    reset () {
      this.$confirm('確認導入模板嗎？注意：該操作會替換當前模板！', '詢問', {
        confirmButtonText: "確認",
        cancelButtonText: "取消",
        type: 'warning'
      }).then(() => {
        this.loading = true;
        let store_id = this.form.store_id;
        this.post('/api/frprint/res_template', {
          store_id: store_id,
          type: this.form.type
        }).then((response) => {
          this.loading = false;
          if (response == 'success') {
            this.$notify({
              showClose: true,
              message: '設置成功！',
              type: 'success',
              offset: 160
            });
          } else {
            this.$notify({
              showClose: true,
              message: '設置失敗，請重試！',
              type: 'error',
              offset: 160
            });
          };
          this.getfrprint_template(this.form.store_id);
        }).catch((err) => {
          this.loading = false;
          console.log(err)
        })
      }).catch(error => {
        console.log(error);
      });
    },
  },
  created () {
    let id = this.$route.params.id;
    if (id > 0) {
      this.form.store_id = id;
      this.getfrprint_template(id);
    }
  }

};
</script>
<style scoped>
.mm-row {
}
</style>
